import React from 'react';
import classNames from 'classnames';
import { createUpdateEffect, useIsomorphicLayoutEffect } from 'ahooks';
import assignWith from 'lodash/assignWith';
export function withNativeProps(props, element) {
    const p = {
        ...element.props,
    };
    if (props.className) {
        p.className = classNames(element.props.className, props.className);
    }
    if (props.style) {
        p.style = {
            ...p.style,
            ...props.style,
        };
    }
    if (props.tabIndex !== undefined) {
        p.tabIndex = props.tabIndex;
    }
    for (const key in props) {
        if (!props.hasOwnProperty(key)) {
            continue;
        }
        if (key.startsWith('data-') || key.startsWith('aria-')) {
            p[key] = props[key];
        }
    }
    return React.cloneElement(element, p);
}
export function toCSSLength(val) {
    return typeof val === 'number' ? `${val}px` : val;
}
export const useIsomorphicUpdateLayoutEffect = createUpdateEffect(useIsomorphicLayoutEffect);
export function mergeProps(...items) {
    function customizer(objValue, srcValue) {
        return srcValue === undefined ? objValue : srcValue;
    }
    let ret = { ...items[0] };
    for (let i = 1; i < items.length; i++) {
        ret = assignWith(ret, items[i], customizer);
    }
    return ret;
}
